<template>
    <div v-if="!!record&&!!record.qualification_type_ids">
        <div class="uk-grid uk-grid-small uk-grid-match">
            <div class="uk-width-1-3">
                <div class="uk-grid uk-grid-small uk-grid-width-1-1">
                    <form-checkbox
                        v-for="qualification_type in qualification_types"
                        :key="qualification_type.id"
                        :id="`qualification-type-${qualification_type.id}`"
                        :value="record.qualification_type_ids.indexOf(qualification_type.id)>=0"
                        :name="`${qualification_type.id}`"
                        :editable="true"
                        @input="toggle_qualification_type"
                    >
                        <span class="uk-text-nowrap">{{ qualification_type.name }}</span>
                    </form-checkbox>
                </div>
            </div>
            <div class="uk-width-2-3">
                <form-text-area
                    id="qualification_notes"
                    name="notes"
                    v-model="record.notes"
                    width="1-1"
                    height="1-1"
                    :editable="is_editable"
                    :required="false"
                    placeholder="Description"
                    @input="save_field"
                />
            </div>
        </div>

        <div class="uk-grid uk-grid-small">
            <div class="uk-width-1-3">
                <div class="uk-grid uk-grid-small uk-grid-width-1-1">
                    <form-checkbox
                        :id="`qualification-type-${resumes_qualification_type.id}`"
                        :value="record.qualification_type_ids.indexOf(resumes_qualification_type.id)>=0"
                        :name="`${resumes_qualification_type.id}`"
                        :editable="true"
                        @input="toggle_qualification_type"
                    >
                        <span class="uk-text-nowrap">{{ resumes_qualification_type.name }}</span>
                    </form-checkbox>
                </div>
            </div>
            <div v-if="has_resumes" class="uk-width-2-3">
                <form-tags-input
                    id="user"
                    name="user"
                    entity="user"
                    :value="record.resumes||[]"
                    :local-options="users"
                    label-field="initials"
                    :editable="is_editable"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_field($event || [], 'resumes')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { orderBy } from "lodash"

import request_for_material_body from "./request_for_material_body"
import string_utilities from "../../../mixins/StringUtilities"

import FormCheckbox from "../../../ui/FormCheckbox"
import FormTextArea from "../../../ui/FormTextArea"
import FormTagsInput from "../../../ui/FormTagsInput"

export default {
    mixins: [request_for_material_body, string_utilities],
    components: {
        FormCheckbox,
        FormTextArea,
        FormTagsInput
    },
    methods: {
        toggle_qualification_type (checked, type) {
            type = parseInt(type) || 0
            if(!type) return
            const qualification_type_ids = this.record.qualification_type_ids.slice()
            const index = qualification_type_ids.indexOf(type)
            if(checked && (index < 0)) qualification_type_ids.push(type)
            else if(!checked && (index >= 0)) qualification_type_ids.splice(index, 1)
            this.save_field(qualification_type_ids, "qualification_type_ids")
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_user_records () {
            return this.entity_records("user").filter(user => {
                return !user.deleted_at
            })
        },
        users () {
            return orderBy(this.raw_user_records, "initials", "asc")
        },
        is_editable () {
            return !!this.editable && !this.sent_at
        },
        raw_qualification_types () {
            return this.dictionary("qualification_types", "name")
        },
        qualification_types () {
            return this.raw_qualification_types.filter(qualification_type => !qualification_type.code_constant || !qualification_type.code_constant.match(/^resumes$/i))
        },
        resumes_qualification_type () {
            if(!this.raw_qualification_types || !this.raw_qualification_types.length) return {}
            return this.raw_qualification_types.find(qualification_type => qualification_type.code_constant && qualification_type.code_constant.match(/^resumes$/i))
        },
        has_resumes () {
            if(!this.record.qualification_type_ids || !this.record.qualification_type_ids.length) return false
            const resume_qualification = this.resumes_qualification_type
            if(!resume_qualification || !resume_qualification.id) return false

            return this.record.qualification_type_ids.indexOf(resume_qualification.id) >= 0
        }
    }
}
</script>
